import React, { Component } from 'react';
import useLogout from '../../hooks/useLogout';
import { Button, Space } from 'antd';

export default function ApprovalPending({ user }) {
    const { logout } = useLogout();

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    width: '100%',
                    height: '100vh',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                }}
            >
                <div
                    style={{
                        width: '500px',
                        border: '1px solid gray',
                        padding: '10px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '13px',
                        display: 'flex',
                        flexDirection: 'column',
                        height: '600px',
                        padding: '0 10px',
                    }}
                >
                    <Space direction="vertical" align="center" style={{ padding: '10px' }}>
                        <img
                            src="https://flixstudio.flixstock.com/images/logo.png"
                            style={{
                                width: '100px',
                                height: '100px',
                            }}
                        ></img>
                        <h2>Approval Pending</h2>
                        <br />
                        <p>Welcome, {user?.name}</p>
                        <h3>We are evaluating your profile</h3>
                        <i>
                            <p>To Ensure the best experience for you, we are evaluating your profile. You will be notified via mail on approval.</p>
                        </i>
                        <Button type="primary" style={{ height: '50px', width: '200px' }} onClick={() => logout()}>
                            Go To Login
                        </Button>
                    </Space>
                </div>
            </div>
        </>
    );
}
